module.exports = __webpack_public_path__ + "img/sparc.6e5017c5.png";